import { IGetOneResponse } from '../util/Types/Generic';
import { Widget } from '../views/DashboardBeta/Context/DashboardContext';
import { ApiService } from './ApiService';

export interface DashboardResponse {
  id: string;
  name?: string;
  status: 'draft' | 'published';
  isDefault?: boolean;
  userId: string;
  widgets: Widget[];
  createdAt: string;
  updatedAt: string;
}

export interface DashboardWidgetPersisted {
  id: string;
  type: Widget['type'];
  title: string;
  layout?: Partial<Widget['layout']> | Record<string, string>;
  chatbotData?: Widget['chatbotData'];
  formData?: Widget['formData'];
  flowData?: Widget['flowData'];
}

export class DashboardService extends ApiService {
  static pathName = '/dashboard';

  static getAllDashboards = (): Promise<IGetOneResponse<DashboardResponse[]>> => {
    return this.get(`${this.pathName}`);
  };

  static getDashboard = (dashboardId: string): Promise<IGetOneResponse<DashboardResponse>> => {
    return this.get(`${this.pathName}/${dashboardId}`);
  };

  static createDashboard = (name?: string): Promise<IGetOneResponse<DashboardResponse>> => {
    return this.post(`${this.pathName}`, name ? { name } : undefined);
  };

  static updateDashboard = (
    dashboardId: string,
    data: { name?: string; status?: 'draft' | 'published'; isDefault?: boolean }
  ): Promise<IGetOneResponse<DashboardResponse>> => {
    return this.patch(`${this.pathName}/${dashboardId}`, data);
  };

  static deleteDashboard = (dashboardId: string): Promise<Record<string, never>> => {
    return this.delete(`${this.pathName}/${dashboardId}`);
  };

  static addWidget = ({
    dashboardId,
    widgetData,
  }: {
    dashboardId: string;
    widgetData: Omit<Widget, 'id'> & { layout: Widget['layout'] };
  }): Promise<IGetOneResponse<DashboardWidgetPersisted>> => {
    return this.post(`${this.pathName}/widgets/${dashboardId}`, widgetData);
  };

  static updateBatchWidgets = (widgets: Widget[]): Promise<IGetOneResponse<any>> => {
    return this.patch(`${this.pathName}/widgets/batch`, { widgets });
  };

  static removeWidget = (widgetId: string): Promise<Record<string, never>> => {
    return this.delete(`${this.pathName}/widgets/${widgetId}`);
  };
}
